export const en = {
  Global: {
    send: 'Send',
    save: 'Save',
    savingInProgress: 'Saving in progress',
    edit: 'Edit',
    amend: 'Amend',
    editProposal: 'Edit proposal',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    proceed: 'Proceed',
    assign: 'Assign',
    submit: 'Submit',
    accepted: 'Accepted',
    denied: 'Denied',
    deny: 'Deny',
    done: 'Done',
    notDone: 'Not done',
    started: 'Started',
    notRelevant: 'Not relevant',
    noInfo: 'No info',
    addComment: 'Add comment',
    noComments: 'No comments',
    comment: 'Comment',
    start: 'Start Date',
    end: 'End Date',
    pending: 'Pending',
    approve: 'Approve',
    approved: 'Approved',
    notApproved: 'Not approved',
    release: 'Release',
    released: 'Released',
    notReleased: 'Not released',
    reopen: 'Reopen',
    requestedBy: 'Requested by',
    requestedAt: 'Requested at',
    proposedDecision: 'Proposed decision',
    proposedCategory: 'Proposed category',
    proposedSubcategory: 'Proposed subcategory',
    search: 'Search',
    noResults: 'No results',
    upload: 'Upload',
    uploading: 'Uploading',
    noFilesUploaded: 'No files uploaded',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    unknown: 'unknown',
    from: 'from',
    to: 'to',
    logout: 'Logout',
    profile: 'Profile',
    group: 'Group',
    code: 'Code',
    confirmationDialogTitle: 'Confirmation needed',
    confirmDeleteFileDialogContent: 'Are you sure that you want to delete this file?',
    report: 'report',
    unsavedAnswers: 'You have unsaved answers. By confirming you will lose all unsaved data.',
    unsavedAnswersActionMode: 'You have unsaved answers. Do you want to save them?',
    noOptions: 'No options',
    actionMode: 'Action Mode',
    reason: 'Reason',
    optional: 'optional',
    choose: 'Choose',
    serialNumberMissing: 'Serial number missing',
    recipientEmails: 'Recipient Emails (one address per line)',
    DatePicker: {
      cancelLabel: 'Cancel',
      okLabel: 'Ok',
      minDateMessage: 'Date should not be before minimal date',
      maxDateMessage: 'Date should not be after maximal date',
      invalidDateMessage: 'Invalid Date Format',
    },
    Errors: {
      authErrorTitle: 'Authentication error!',
      authErrorParagraph1: 'You are not authorized to access this app.',
      authErrorParagraph2: 'Please contact your admin.',
      authErrorParagraph3: 'Or logout from Active Directory and try again.',
      pageNotFound: 'Page not found',
      pageNotFoundParagraph1: 'We can\'t find this page',
      back: 'Homepage',
      rotateDevice: 'Please rotate your device.',
    },
    Feedback: {
      error: 'Something went wrong... Action failed.',
      authentication: 'Authenticating... Please wait',
      success: 'Action completed successfully',
      limitReached: 'Approval limit is reached.',
      requestHasBeenSentToApprover: 'Request has been sent to approver.',
      noQuestions: 'No questions for selected product family.',
      decisionNotSend: 'Decision was not successfully sent to sap.',
      noLimitForCC: 'You don\'t have commercial limit set for this customer center.',
      jobCostDoesNotExist:'Job Cost from SAP Job does not exist in PARS database.',
      materialNumberBrandDoesNotExist: 'Material number brand does not exist.',
      jobIsLocked: 'Job is locked.',
      noPicturesAreUploaded: 'No pictures are uploaded',
      rateIsProvided: 'Rate has successfully been registered',
      rateHasToBeDifferent: 'Rate decision has to be different than the old one.',
    },
    Status: {
      title: 'Status',
      awaitingEquipment: 'Awaiting equipment',
      equipmentReceivedWithDocumentation: 'Equipment received with documentation',
      jobReleased: 'Job released',
      productEvaluation: 'Product evaluated',
      strippedAndDecontaminated: 'Stripped and decontaminated',
      builtAndTested: 'Built and tested',
      shipped: 'Shipped',
      technicalAndCommercialDecision: 'Technical and commercial decision',
      finalReportReleased: 'Final report released',
      closed: 'Closed',
      productInvestigation: 'Product investigation',
      customerHold: 'Customer hold',
      notStarted: 'Not started',
    },
    Roles: {
      RECEIVING: 'Receiving',
      SERVICE_ENGINEER: 'Service engineer',
      FAILURE_ANALYSIS_ENGINEER: 'Failure analysis engineer',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'Senior failure analysis engineer',
      FAILURE_ANALYSIS_MANAGER: 'Failure analysis manager',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'Service technology center manager',
      QUALITY_MANAGER: 'Quality manager',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'Service technical support team',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'Product company technical support team',
      DIVISION_OR_BUSINESS_AREA: 'Division or business area',
      CUSTOMER_CENTER: 'Customer center',
      CUSTOMER: 'Customer',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'Customer center service engineer',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer',
      SUPERADMIN: 'Superadmin',
      ZONE_LEADER: 'Zone leader',
      QUESTION_ADMIN: 'Question admin',
      DISTRIBUTOR: 'Distributor',
    },
    Permissions: {
      VIEW_JOB: 'View job',
      EDIT_JOB: 'Edit job',
      IMPORT_JOB_FROM_SAP: 'Import job from SAP',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: 'Level 3 release for investigation',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: 'Level 4 release for investigation',
      GENERATE_AND_DOWNLOAD_REPORT: 'Generate and download report',
      VIEW_LOG: 'View log',
      VIEW_CONVERSATION: 'View conversation',
      PARTICIPATE_IN_CONVERSATION: 'Participate in conversation',
      TAG_INTEREST: 'Tag interest',
      ADD_REMOVE_FROM_TEAM: 'Add and remove from team',
      CREATE_JOB: 'Create job',
      DELETE_JOB: 'Delete job',
      REQUEST_DIFFERENT_REPORT_LEVEL: 'Request different report level',
      APPROVE_DIFFERENT_REPORT_LEVEL: 'Approve different report level',
      WARRANTY_DECISION: 'Warranty decision',
      GOODWILL_DECISION: 'Goodwill decision',
      LEVEL_1_REPORT_APPROVAL: 'Level 1 report approval',
      LEVEL_2_REPORT_APPROVAL: 'Level 2 report approval',
      LEVEL_3_REPORT_APPROVAL: 'Level 3 report approval',
      LEVEL_4_REPORT_APPROVAL: 'Level 4 report approval',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen',
      REOPEN_REPORT: 'Reopen report',
      REQUEST_FAILED_PARTS: 'Request failed parts',
      SHIP_FAILED_PARTS: 'Ship failed parts',
      PRINT_INPUT_SHEETS: 'Print input sheets',
      ADMINISTRATE_QUESTIONS: 'Administrate questions',
      ADMINISTRATE_DATA: 'Administrate data',
      DOWNLOAD_PICTURES: 'Download pictures',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade',
      APPROVE_TECHNICAL_DECISION_LEVEL_4: 'Approve technical decision level 4'
    },
    Alerts: {
      noAlerts: 'No alerts',
      healthAndSafetyInformationMissing: 'Health and Safety information missing',
      jobNotReleased: 'Job not released',
      noRecentStatusChange: 'No recent status change',
      noServiceTechnicalSupportInvolvement: 'No service technical support involved yet',
      noProductCompanyTechnicalSupportInvolvement: 'No product company technical support involved yet',
      noTechnicalWarrantyDecision: 'No technical warranty decision',
      noCommercialDecision: 'No commercial decision',
      reportNotApproved: 'Report not approved',
    },
    Actions: {
      ADD_JOB: 'Added job',
      IMPORT_JOB: 'Imported job from SAP',
      DELETE_JOB: 'Deleted job',
      VERIFY_JOB: 'Verified job',
      SET_PRICE: 'Edited job - Cost',
      ADD_TEAM_MEMBER: 'Team member added',
      REMOVE_TEAM_MEMBER: 'Team member removed',
      REQUEST_REPORT_LEVEL_CHANGE: 'Requested report level change',
      APPROVE_REPORT_LEVEL_CHANGE: 'Approved report level change',
      DENY_REPORT_LEVEL_CHANGE: 'Denied report level change',
      REQUEST_REPORT_APPROVAL: 'Requested report approval',
      APPROVE_REPORT_APPROVAL: 'Approved report approval',
      DENY_REPORT_APPROVAL: 'Denied report approval',
      SET_WARRANTY_START_DATE: 'Edited job - Warranty start date',
      SET_WARRANTY_END_DATE: 'Edited job - Warranty end date',
      EQUIPMENT_SERIAL_NUMBER_EDITED: 'Edited job - Equipment serial number',
      MATERIAL_NUMBER_EDITED: 'Edited job - Material number',
      WORKED_ON_JOB: 'Edited job - Update form',
      UPLOADED_FILE_ON_JOB: 'Edited job - Uploaded a file',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Requested technical warranty decision',
      APPROVE_TECHNICAL_WARRANTY_DECISION: 'Approved technical warranty decision',
      DENY_TECHNICAL_WARRANTY_DECISION: 'Denied technical warranty decision',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: 'Approved commercial warranty decision',
      DENY_COMMERCIAL_WARRANTY_DECISION: 'Denied commercial warranty decision',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: 'Nullified commercial warranty decision',
      SEND_COMMENT: 'Comment added',
      REOPEN_REPORT: 'Edited job - Reopen report',
      AWAITING_EQUIPMENT_STATUS_SET: 'Edited status - Awaiting equipment - done',
      AWAITING_EQUIPMENT_STATUS_RESET: 'Edited status - Awaiting equipment - not done',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: 'Edited status - Equipment receieved with documentation - done',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: 'Edited status - Equipment receieved with documentation - not done',
      JOB_RELEASED_STATUS_SET: 'Edited status - Job released - done',
      JOB_RELEASED_STATUS_RESET: 'Edited status - Job released - not done',
      PRODUCT_EVALUATION_STATUS_SET: 'Edited status - Product evaluation - done',
      PRODUCT_EVALUATION_STATUS_RESET: 'Edited status - Product evaluation  - not done',
      PRODUCT_INVESTIGATION_STATUS_SET: 'Edited status - Product investigation - done',
      PRODUCT_INVESTIGATION_STATUS_RESET: 'Edited status - Product investigation  - not done',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: 'Edited status - Stripped and decontaminated - done',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: 'Edited status - Stripped and decontaminated - not done',
      BUILT_AND_TESTED_STATUS_SET: 'Edited status - Build and tested  - done',
      BUILT_AND_TESTED_STATUS_RESET: 'Edited status - Build and tested - not done',
      SHIPPED_STATUS_SET: 'Edited status - Shipped - done',
      SHIPPED_STATUS_RESET: 'Edited status - Shipped  - not done',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: 'Edited status - Technical and commercial decision - done',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: 'Edited status - Technical and commercial decision  - not done',
      FINAL_REPORT_RELEASED_STATUS_SET: 'Edited status - Final report released  - done',
      FINAL_REPORT_RELEASED_STATUS_RESET: 'Edited status - Final report released - not done',
      CLOSED_STATUS_SET: 'Edited status - Closed  - done',
      CLOSED_STATUS_RESET: 'Edited status - Closed  - not done',
      CUSTOMER_HOLD_STATUS_SET: 'Edited status - Customer hold  - done',
      CUSTOMER_HOLD_STATUS_RESET: 'Edited status - Customer hold  - not done',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: 'Edited technical decision category',
      GENERATE_ALERT: 'Generated alert',
      INITIAL_WARRANTY_CODE_EDITED: 'Initial warranty code changed',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision',
      CHOOSE_RELEASE_METHOD: 'Chose release method',
    },
    TechnicalWarranty: {
      ACCEPTED: 'Accepted',
      DENIED: 'Denied',
      AGREE: 'Agree',
      DISAGREE: 'Disagree',
      MANUFACTURING: 'Manufacturing',
      DESIGN: 'Design',
      VENDOR: 'Vendor',
      PROCESS: 'Process',
      INHOUSE_REPAIR: 'In-house repair',
      FIELD_SERVICE_REPAIR: 'Field service repair',
      REFURBISHED_MATERIAL: 'Refurbished material (service division)',
      NO_FAULT_FOUND: 'No fault found',
      WARRANTY_EXPIRED: 'Out of standard warranty period',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
      WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
      CUSTOMER_FAULT: 'Customer fault',
      OTHER: 'Other',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Agree with technical decision',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Disagree with technical decision',
      SPARE_PART: 'Spare part (Service Division)',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: 'Contractual agreement',
      GOODWILL_ACCEPTED: 'Goodwill accepted',
      CHARGEABLE_TO_CUSTOMER: 'Chargeable to customer',
      EXTENDED_WARRANTY: 'Extended warranty',
      SERVICE_CONTRACT: 'Service contract',
      OTHER: 'Other',
      SEMICONDUCTOR: 'Semiconductor',
      SCIENTIFIC: 'Scientific',
      INDUSTRIAL: 'Industrial',
      SEMICONDUCTOR_SERVICE: 'Semiconductor Service',
      VACUUM_TECHNIQUE_SERVICE: 'Vacuum Technique Service',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
      SCIENTIFIC_CC: 'Scientific Cooling and Cryo',
      SCIENTIFIC_MI: 'Scientific Measurement and Instrumentation',
      SCIENTIFIC_VG: 'Scientific Vacuum Generation'
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: 'No need for technical team involvement',
      GOLDENEYE_UPLINK: 'GoldenEye uplink',
      ON_SITE_PRESENCE: 'On-site presence',
      RETURN_TO_PRODUCT_COMPANY: 'Return to product company',
      SEND_BACK_PARTS: 'Send back parts',
    },
    Forms: {
      fields: {
        basicInformation: 'Basic information',
        customerCenter: 'Customer center',
        serviceTechnologyCenter: 'Service technology center',
        reportLevel: 'Report level',
        initialWarrantyCode: 'Initial warranty code',
        technicalDecision: 'Technical decision',
        commercialDecision: 'Commercial decision',
        price: 'Cost',
        jobStatus: 'Job status',
        reportCompletion: 'Report completion',
        alerts: 'Alerts',
        team: 'Team',
        customer: 'Customer',
        customerContact: 'Customer contact',
        jobDetails: 'Job details',
        jobType: 'Job type',
        serviceProduct: 'Service product',
        equipment: 'Equipment',
        failure: 'Failure',
        symptom: 'Symptom',
        address: 'Address',
        contactPerson: 'Contact person',
        email: 'Email',
        phone: 'Phone',
        customerPurchaseOrderNumber: 'Customer purchase order number',
        equipmentWarranty: 'Equipment warranty',
        serviceWarranty: 'Service warranty',
        reportStatus: 'Report status',
        reopen: 'Reopen',
        releaseJob: 'Release job',
        notifyTeam: 'Notify team',
      },
      errors: {
        required: 'The field is required',
        tel: 'Please enter a valid phone number.',
        email: 'Please enter a valid email.',
        number: 'Only numbers are allowed',
        alphanumeric: 'No special characters allowed',
        text: 'Please enter a valid value',
        unknown: 'Something went wrong...',
        belowZero: 'Value cannot be less than 0.',
        uploadFailed: 'Failed to upload',
        maxFileSize: 'Maximum size allowed is',
        maxLength: maxLength => `Max ${maxLength} characters allowed`,
        minLength: minLength => `Please enter at least ${minLength} characters`,
      },
    },
    FaultCodes: {
      fallbackDescription: 'No description for this code',
      jobTypeDescription: {
        'JT001': 'Description for job type JT001',
        'JT002': 'Description for job type JT002',
      },
      faultCodeDescription: {
        'FC001': 'Description for fault code FC001',
        'FC002': 'Description for fault code FC002',
      },
      symptomCodeDescription: {
        'SC001': 'Description for symptom code SC001',
        'SC002': 'Description for symptom code FC002',
      },
    },
    Progress: {
      title: 'Progress',
      productReceived: 'Product received',
      productEvaluation: 'Product evaluation',
      stripObservation: 'Strip observation',
      technicalInvestigation: 'Technical investigation',
      conformityTest: 'Conformity test',
    },
  },
  Profile: {
    title: 'Profile',
    name: 'Name',
    role: 'Role',
    company: 'Company',
    rights: 'Rights',
    linked: 'User is linked to',
  },
  Jobs: {
    title: 'Jobs',
    filters: 'Filters',
    myJobs: 'My jobs',
    otherJobs: 'Other jobs',
    noJobsToDisplay: 'No jobs to display.',
    pleaseUseTheSearchBar: "Please use the search bar.",
    id: 'Id',
    createdAt: 'Created at',
    status: 'Status',
    customer: 'Customer',
    serialProductNumber: 'Ser. product nr.',
    materialNumber: 'Material nr.',
    equipmentSerialNumber: 'Equipment s. nr.',
    customerCenterPlantCode: 'C.c. plant code',
    serviceTechnologyCenterPlannerGroup: 'S.t.c. planner group',
    handledBy: 'Handled by',
    reportLevel: 'Report level',
    materialDescription: 'Material description',
    customerName: 'Customer name',
    receivedDate: 'Received date',
    customerCenterName: 'CC name',
    serviceOrderNumber: 'Service order number',
    workFlow: 'Work flow',
    analysisFlow: 'Analysis flow',
    productReceived: 'Product received',
    productEvaluation: 'Product evaluation',
    stripObservation: 'Strip observation',
    technicalInvestigation: 'Technical investigation',
    conformityTest: 'Conformity test',
    notificationNumber: 'Notification number',
  },
  Job: {
    editButton: 'Edit',
    progress: 'Progress',
  },
  Filters: {
    filtersTitle: 'Filters',
    applyButton: 'Apply',
    clearButton: 'Clear',
    sorting: 'Sorting',
    sortNew: 'Sort newest',
    sortOld: 'Sort oldest',
    date: 'Date',
    dateFrom: 'From',
    dateTo: 'To',
    reportLevel: 'Report level',
    status: 'Status',
    customerNumber: 'Customer number',
    customerName: 'Customer name',
    serviceProductNumber: 'Service product number',
    materialNumber: 'Material number',
    equipmentSerialNumber: 'Equipment serial number',
    stcPlannerGroup: 'STC planner group',
    selectstcPlannerGroup: 'Select STC planner group',
    CCplant: 'CC plant',
    selectCCplant: 'Select CC plant',
    distributor: 'Distributor',
    selectDistributor: 'Select Distributor',
    failureAnalysisEngineerNotAssigned: 'Not assigned to failure analysis engineer',
    openedJobs: 'Opened jobs',
    publishedJobs: 'Published jobs',
    unreadMessages: 'Unread messages',
    pendingMyApproval: 'Pending my approval',
    notificationNumber: 'Notification number',
    serviceOrderNumber: 'Service order number',
  },
  AddJob: {
    formSections: {
      title: 'Add new job',
      createdAt: 'Creation date',
      button: 'Save',
      basicInformation: {
        title: 'Basic information',
        fieldLabels: {
          equipmentSerialNumber: 'Equipment serial number',
          serviceTechnologyCenter: 'Service technology center',
          customerCenter: 'Customer center',
          reportLevel: 'Report level',
          initialWarrantyCode: 'Initial warranty code',
          customerPurchaseOrderNumber: 'Customer purchase order number',
          responsibleSalesPerson: 'Responsible sales person',
          customerCenterContactName: 'Customer center contact name',
          customerCenterContactEmail: 'Customer center contact email',
        },
      },
      jobType: {
        title: 'Type',
        fieldLabels: {
          jobType: 'Type',
          jobTypeDescription: 'Description',
        },
      },
      searchMaterialNumber: 'Search material number',
      materialNumber: {
        title: 'Material number',
        fieldLabels: {
          materialNumber: 'Material number',
          materialNumberDescription: 'Description',
        },
      },
      serviceProductNumber: {
        title: 'Service product number',
        fieldLabels: {
          serviceProductNumber: 'Service product number',
          serviceProductNumberDescription: 'Description',
        },
      },
      symptomCode: {
        title: 'Symptom code',
        fieldLabels: {
          scGroups: 'Symptom code group',
          symptomCode: 'Symptom code',
          symptomCodeDescription: 'Description',
        },
      },
      faultCode: {
        title: 'Fault code',
        fieldLabels: {
          fcGroups: 'Fault code group',
          faultCode: 'Fault code',
          faultCodeDescription: 'Description',
        },
      },
      customerInformation: {
        title: 'Customer information',
        fieldLabels: {
          customerId: 'Customer ID',
          customerName: 'Name',
          customerAddress: 'Address',
          customerContact: 'Contact person',
          customerEmail: 'Email address',
          customerPhone: 'Phone number',
        },
      },
    },
  },
  ImportJob: {
    title: 'Import job',
    date: 'Date of import',
    importButton: 'Import',
    searchTitle: 'Search for a job to import',
    searchSubtitle: 'min 5 characters, no leading zeros',
    searchButton: 'Search',
    notificationNumberLabel: 'Notification number',
    serviceOrderNumberLabel: 'Service order number',
    linkTo: 'Link to',
    openJobsFoundForSerNumber: 'Open jobs found for this serial number',
    importJobAsNew: 'Import job as new',
    jobIsImportedAlready: 'Job is imported already',
    importing: 'Importing in progress...',
    linking: 'Linking in progress...',
    columns: {
      sourceId: 'Brand',
      notificationNumber: 'Notification Nr.',
      serviceOrderNumber: 'Service Order Nr.',
      serialNumber: 'Serial Nr.',
      jobTypeDescription: 'Description',
      customerName: 'Customer Name',
    },
  },
  SingleJob: {
    title: 'Job',
    createdAt: 'Created at',
    modifiedAt: 'Last modified at',
    serviceOrderNumber: 'Service order number',
    notificationNumber: 'Notification number',
    receivedProduct: 'Received product',
    productEvaluation: 'Product evaluation',
    stripObservation: 'Strip observation',
    technicalInvestigation: 'Technical investigation',
    conformityTest: 'Conformity test',
    log: 'Log',
    conversation: 'Conversation',
    noTechPossibilityParagraph1: 'This STC doesn\'t have testing capacity for this job.',
    noTechPossibilityParagraph2: 'Please close the job and send the pump to another STC.',
    downloadPictures: 'Download pictures',
    downloadAllPictures: 'Download all pictures',
    downloadPicturesFrom: 'Download pictures from',
    downloadInProgressPleaseWait: 'Download in progress... Please wait',
  },
  JobSummary: {
    title: 'Job summary',
    createdAt: 'Created at',
    modifiedAt: 'Last modified at',
    reportLevelDialogTitle: 'Report level',
    reportLevelDialogContent: 'Set requested report level',
    reportLevelDialogInitialWarrantyCodeLabel: 'Initial warranty code',
    approveReportLevelDialogTitle: 'Approve report level request',
    technicalWarrantyDialogTitle: 'Propose technical decision',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal',
    rateTechnicalDecisionTitle: 'Rate technical decision',
    rate: 'Rate',
    reclassify: 'Reclassify',
    technicalWarrantyDialogContent: 'Warranty decision',
    technicalWarrantyDialogCategory: 'Warranty category',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: 'Approve technical warranty proposal',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: 'Reclassify technical decision category',
    commercialDecisionDialogTitle: 'Make commercial decision',
    commercialDecisionDialogContent: 'Commercial decision',
    commercialDecisionDialogCategory: 'Commercial category',
    approveCommercialDecisionDialogTitle: 'Approve proposal',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision',
    editPriceDialogTitle: 'Edit Cost',
    editPriceLabel: 'Edit',
    proposedDate: 'Proposed date',
    releaseJobDialogTitle: 'Release job (contact PC)',
    chooseReleaseJobMethodTitle: 'Choose release job method',
    editChosenReleaseJobMethodTitle: 'Edit chosen release job method',
    releaseJobDialogLabel: 'Select method',
    reportStatusDialogTitle: 'Propose to change report status',
    reportStatusDialogContent: 'This will make a request for report approval.',
    reportStatusDialogMessage: 'Please select SAP cause code in PARS before submitting for report approval',
    approveReportStatusDialogContent: 'Are you sure that you want to reopen this job?',
    approveReportStatusDialogTitle: 'Report approval request',
    editJobStatusDialogTitle: 'Edit job status',
    editEquipmentSerialNumberDialogTitle: 'Edit equipment serial number',
    editEquipmentSerialNumberDialogFieldLabel: 'Equipment serial number',
    editMaterialNumberDialogTitle: 'Edit material number',
    editMaterialNumberDialogFieldLabel: 'Material number',
    editMaterialNumberDialogDescriptionFieldLabel: 'Description',
    warrantyStartDialogTitle: 'Edit warranty start date',
    warrantyStartDateLabel: 'Warranty start date',
    warrantyEndDialogTitle: 'Edit warranty end date',
    warrantyEndDateLabel: 'Warranty end date',
    verifyJobDialogTitle: 'Verify job',
    verifyJobDialogContent: 'This action will lock material and equipment numbers for editing. Are you sure that the following data is correct?',
    materialNumber: 'Material number',
    equipmentSerialNumber: 'Equipment serial number',
    deleteConfirmationDialogTitle: 'Confirmation needed',
    deleteConfirmationDialogContent: 'Are you sure that you want to delete this job?',
    teamDialogTitle: 'Add team member',
    removeTeamMemberDialogTitle: 'Remove team member',
    removeTeamMemberDialogContent: 'Are you sure that you want to remove this member from the team?',
    technicalDecisionReason: 'Technical decision reason',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    changeReportLevelReason: 'Reason for changing report level',
    rateTechnicalDecisionComment: 'Comment on rating of technical decision',
    decisionReason: 'Decision reason',
    commercialDecisionReason: 'Commercial decision reason',
    approveReportLevelDialogRequestedLevel: 'Requested level',
    approveReportLevelDialogPreviousLevel: 'Previous level',
    approveReportLevelDialogInitialWarrantyCode: 'Initial warranty code',
    initialWarrantyCode: 'Initial warranty code',
    shipToAddress: 'Ship to address',
    partNumbers: 'Part numbers',
    failureReason: 'Failure reason',
    symptomReason: 'Symptom reason',
    chooseMethod: 'Choose method',
    chosenMethod: 'Chosen method',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add.',
    deleteImportedJob: 'Delete imported',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job?',
  },
  LogSection: {
    title: 'Log',
    sib: 'SIB',
    initialWarrantyCode: 'Initial warranty code',
  },
  ReportsDialog: {
    title: 'Generate report',
    confirmButton: 'Generate',
    reportFormat: 'Report format',
    reportTemplate: 'Report template',
  },
  ActionMode: {
    takePicture: 'Take a picture',
    takeStandardPicture: 'Take standard picture',
    takeNonStandardPicture: 'Take non-standard picture',
    lastScreenMessage: 'You have reached the end of this section. Please close this window.',
    lastScreenMessageUnsavedAnswers: 'You have reached the end of this section. Please save your answers.'
  },
  InputFile: {
    special: 'Non-standard picture',
    upload: 'Upload',
    uploadStandardPicture: 'Upload standard picture',
    uploadNonStandardPicture: 'Upload non-standard picture',
    commentPicture: 'Comment picture',
    confirmButtonText: 'Save comment',
    moveFileModal: {
      title: 'Move file',
      confirmButtonText: 'Move',
      selectSubsection: 'Select subsection',
      selectQuestion: 'Select question',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: 'Move',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/en.js